import { CreateAccountInvitationPayload } from '../../../modules/users/invitations/types';
import { sendInvitations } from '../../../modules/users/invitations/userInvitations.repository';
import { getUsers } from '../../../modules/users/users.repository';
import { Account } from '../../../modules/users/types';

export const sendInvitationEmailsUseCase = async (
  userInvitationPayload: CreateAccountInvitationPayload,
): Promise<void> => {
  await sendInvitations(userInvitationPayload);
};

export const getUsersListUseCase = async (): Promise<Account[]> => {
  // TODO remove dependency
  const response = await getUsers(1, 1000);
  return response.items;
};